import { view } from '@yola/ws-sdk';
import getCompiledFontPairConfig from './compile-font-pair-config';

const getFontsConfig = (fontsId, fonts) => {
  const selectedFonts = fonts.find((fontsPair) => fontsPair.id === fontsId);
  const liveDocument = view.accessors.getLiveDocument();

  if (!selectedFonts) return null;

  const compiledConfig = selectedFonts.isCustom
    ? getCompiledFontPairConfig(selectedFonts)
    : selectedFonts;

  return {
    google: {
      families: compiledConfig.variables.usedFonts.split(' | '),
    },
    classes: false,
    context: liveDocument.defaultView,
  };
};

export default getFontsConfig;
